"use client";

import { ButtonLink, TEmployerCta } from "@shared/cms";
import { useIsTablet } from "@ubud-ui/react-ui-kit";

export function EmployerCta({ title, description, button, backgroundDesktop, backgroundMobile }: TEmployerCta) {
  const isTablet = useIsTablet();

  return (
    <section className="pb-14 sm:pb-24">
      <div className="container">
        <div
          className="py-14 sm:20 rounded-xl bg-primary text-white bg-cover bg-center"
          style={{ backgroundImage: !isTablet ? "url(" + backgroundDesktop.url + ")" : "url(" + backgroundMobile.url + ")" }}
        >
          <div className="max-w-[552px] mx-auto text-center px-6">
            <h2 className="text-2xl sm:text-4xl font-bold text-white">{title}</h2>
            {description && <div className="text-gray-50 mt-4">{description}</div>}
            {button && (
              <div className="mt-10">
                <ButtonLink {...button} />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
